import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Typography, Spin, Alert, Form, Input, Button, Card } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { fetchPortalPost, unlockPortalPost } from '../../services/portalApi';
import PortalPostArticle from '../../components/portal/PortalPostArticle';
import '../../components/portal/portal.css';

const { Paragraph } = Typography;

const PortalPostDetailScreen = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unlocking, setUnlocking] = useState(false);
  const [unlockError, setUnlockError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetchPortalPost(slug)
      .then((d) => {
        if (!cancelled) setPost(d);
      })
      .catch((e) => {
        if (!cancelled) setError(e.response?.status === 404 ? 'Post not found' : (e.message || 'Failed to load'));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const onUnlock = async ({ password }) => {
    setUnlocking(true);
    setUnlockError(null);
    try {
      const data = await unlockPortalPost(slug, password);
      setPost(data);
    } catch (e) {
      setUnlockError(e.response?.data?.detail || 'Incorrect password');
    } finally {
      setUnlocking(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 80 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        type="error"
        message={error}
        action={<Link to="/posts">Back to posts</Link>}
        style={{ marginTop: 24 }}
      />
    );
  }

  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 0 64px' }}>
      <Link to="/posts" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginBottom: 20, fontWeight: 500 }}>
        <ArrowLeftOutlined /> Posts
      </Link>

      {post.needsPassword && !post.bodyHtml ? (
        <>
          <PortalPostArticle post={{ ...post, bodyHtml: null, attachments: [], tagNames: [] }} compact />
          <Card style={{ maxWidth: 420, borderRadius: 10, marginTop: 24 }}>
            <Paragraph>This post is password protected. Enter the password to continue reading.</Paragraph>
            <Form onFinish={onUnlock} layout="vertical">
              <Form.Item name="password" rules={[{ required: true, message: 'Enter the password' }]}>
                <Input.Password placeholder="Password" size="large" />
              </Form.Item>
              {unlockError && <Alert type="error" message={unlockError} style={{ marginBottom: 12 }} />}
              <Button type="primary" htmlType="submit" loading={unlocking} block>
                Unlock
              </Button>
            </Form>
          </Card>
        </>
      ) : (
        <PortalPostArticle post={post} compact />
      )}
    </div>
  );
};

export default PortalPostDetailScreen;
